/**
 * Workshop Cart Integration
 *
 * Add-to-cart: JSON (items array). Properties için güvenilir; FormData properties kaybettirebilir.
 */

// Global init guard: prevent duplicate execution (idempotent)
// CRITICAL: This prevents the script from executing twice if loaded multiple times
(function() {
  'use strict';
  
  if (window.__WORKSHOP_CART_INIT__) {
    if (window.__DEBUG_WORKSHOP_CAPACITY__) {
      console.log('[Workshop Cart] Already initialized, skipping');
    }
    return; // Exit early to prevent duplicate execution
  }
  window.__WORKSHOP_CART_INIT__ = true;

document.addEventListener('DOMContentLoaded', () => {
  // Guard: prevent double event binding
  if (window.__workshopCartBound) {
    if (window.__DEBUG_WORKSHOP_CAPACITY__) {
      console.log('[Workshop Cart] Event listeners already bound, skipping');
    }
    return;
  }
  window.__workshopCartBound = true;

  if (window.__DEBUG_WORKSHOP_CAPACITY__) {
    console.log('[Workshop Cart] Initializing event listeners');
  }

  /**
   * JSON items format for cart/add.js (Shopify documented format).
   * Properties are reliably stored as line item properties -> Cart Transform attributes.
   */
  function buildCartAddPayload(variantId, quantity, properties, sections = []) {
    var item = {
      id: parseInt(String(variantId), 10),
      quantity: Math.max(1, parseInt(String(quantity), 10) || 1),
      properties: {}
    };
    for (var k in (properties || {})) {
      if (properties[k] != null && properties[k] !== '') {
        item.properties[k] = String(properties[k]);
      }
    }
    var payload = { items: [item] };
    if (Array.isArray(sections) && sections.length > 0) {
      payload.sections = sections.join(',');
      payload.sections_url = (typeof window !== 'undefined' && window.location && window.location.pathname) || '/';
    }
    return payload;
  }

  // Intercept all product form submissions
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    
    // Only handle product add-to-cart forms
    if (!form || !form.action || !form.action.includes('/cart/add')) return;
    if (!form.classList.contains('form') || form.getAttribute('data-type') !== 'add-to-cart-form') return;

    // Check if this is a workshop product
    const workshopInput = form.querySelector('[name="properties[workshop]"]');
    if (!workshopInput || workshopInput.value !== 'true') return;

    e.preventDefault();
    if (window.__WORKSHOP_ADDING_TO_CART__) return;

    // Get selected event data from global selection state
    const selection = window.__WORKSHOP_SELECTION__;
    if (!selection || !selection.eventId) {
      alert('Please select an event before adding to cart.');
      return;
    }

    const selectedEventId = selection.eventId;
    
    // Get booking container for resolver access
    const bookingContainer = document.querySelector('.workshop-booking');
    if (!bookingContainer) {
      console.warn('Workshop cart: booking container not found');
      return;
    }

    // Find the selected event card to get event data
    const eventsRoot = bookingContainer.querySelector('[data-workshop-events]');
    if (!eventsRoot) {
      console.warn('Workshop cart: events list not found');
      return;
    }

    const selectedCard = eventsRoot.querySelector(`.workshop-event-card[data-event-id="${CSS.escape(selectedEventId)}"]`);
    if (!selectedCard) {
      alert('Selected event not found. Please try again.');
      return;
    }

    if (window.wbEventBooking && typeof window.wbEventBooking.isBookable === 'function') {
      if (!window.wbEventBooking.isBookable(selectedCard)) {
        alert('This session is sold out. Please choose another time.');
        return;
      }
    }

    // Get event handle from card (must be metaobject handle, never numeric event_id)
    // CRITICAL: Block add-to-cart if handle is missing or numeric
    const datasetEventHandle = selectedCard.dataset.eventHandle || '';
    const eventHandle = datasetEventHandle;
    const looksNumeric = /^\d+$/.test(eventHandle);
    
    if (!eventHandle || looksNumeric || eventHandle === String(selectedEventId)) {
      const errorMsg = 'This workshop event is not available for booking. Please select a different event.';
      alert(errorMsg);
      console.error('[Workshop Cart] Add to cart blocked - invalid event_handle:', {
        eventHandle: eventHandle,
        selectedEventId: selectedEventId,
        looksNumeric: looksNumeric,
        reason: !eventHandle ? 'missing' : (looksNumeric ? 'numeric' : 'equals_event_id')
      });
      return;
    }

    // Optional debug logs
    if (window.__DEBUG_CART_ADD__ === true) {
      console.log('[Workshop Cart] Add to cart - event handle validation:', {
        eventId: selectedEventId,
        eventHandle: eventHandle,
        datasetEventHandle: datasetEventHandle,
        propertiesEventHandle: eventHandle
      });
    }

    // Get variant ID: form's [name="id"] or workshop hidden input #workshop-variant
    const variantIdInput = form.querySelector('[name="id"]') || bookingContainer.querySelector('#workshop-variant');
    if (!variantIdInput) {
      console.warn('Workshop cart: variant ID not found');
      return;
    }
    const variantId = variantIdInput.value;

    // CRITICAL FIX: Resolve price FRESH on every add-to-cart to prevent price leakage
    // Workshop uses button cards (data-base-price), not a select. Get base price from active variant button.
    const activeVariantBtn = bookingContainer.querySelector('.wb-variant-btn.is-active');
    const basePriceCents = activeVariantBtn && activeVariantBtn.dataset.basePrice
      ? Number(activeVariantBtn.dataset.basePrice)
      : null;
    if (!basePriceCents || Number.isNaN(basePriceCents) || basePriceCents <= 0) {
      alert('Unable to determine base price. Please refresh and try again.');
      return;
    }

    // Use selection state (from dataset attributes)
    const state = selection.state || selectedCard.dataset.state || '';
    const city = selection.city || selectedCard.dataset.city || '';
    const venueName = selection.venue || selectedCard.dataset.venueName || '';
    const cityKey = selectedCard?.dataset?.cityKey ? String(selectedCard.dataset.cityKey).trim() : '';
    const venueHandle = selectedCard?.dataset?.venueHandle ? String(selectedCard.dataset.venueHandle).trim() : '';

    // CRITICAL: Resolve price ONLY on Add to Cart (fresh resolution)
    let resolvedPriceCents = basePriceCents;
    if (window.resolveWorkshopPrice && typeof window.resolveWorkshopPrice === 'function') {
      try {
        // Get workshop product ID from booking container
        const workshopProductId = bookingContainer?.dataset?.productId || '';
        resolvedPriceCents = window.resolveWorkshopPrice({
          basePriceCents: basePriceCents,
          eventId: selectedEventId,
          state: state,
          city: city,
          cityKey: cityKey,
          venueName: venueName,
          venueHandle: venueHandle,
          variantId: variantId,
          workshopId: workshopProductId,
        });
      } catch (err) {
        console.warn('Workshop cart: Price resolver failed, using base price', err);
        resolvedPriceCents = basePriceCents;
      }
    }

    if (!Number.isFinite(resolvedPriceCents) || resolvedPriceCents <= 0) {
      alert('Unable to determine price. Please refresh and try again.');
      return;
    }

    // Build display properties (for cart/checkout UI) from selection state
    const displayCity = state ? `${city}, ${state}` : city;
    const displayVenue = venueName;
    const displayDatetime = selection.datetime || '';
    const bookingDetailsVisible = `${displayCity || ''}${displayVenue ? ` — ${displayVenue}` : ''}${displayDatetime ? ` · ${displayDatetime}` : ''}`.trim();
    const venueContact = (function pickVenueContact(card) {
      if (!card) return { address: '', phone: '', hours: '' };
      var ev = card._wbEv && typeof card._wbEv === 'object' ? card._wbEv : null;
      var venueEl = typeof card.closest === 'function' ? card.closest('.wb-venue-card') : null;
      var venue = venueEl && venueEl._wbVenue && typeof venueEl._wbVenue === 'object' ? venueEl._wbVenue : null;
      function firstStr() {
        for (var i = 0; i < arguments.length; i++) {
          var s = arguments[i] == null ? '' : String(arguments[i]).trim();
          if (s) return s;
        }
        return '';
      }
      return {
        address: firstStr(
          ev && ev.venue_address,
          ev && ev.address,
          card.dataset && card.dataset.venueAddress,
          venue && venue.venue_address,
          venue && venue.address
        ),
        phone: firstStr(
          ev && ev.venue_phone,
          ev && ev.phone,
          card.dataset && card.dataset.venuePhone,
          venue && venue.venue_phone,
          venue && venue.phone
        ),
        hours: firstStr(
          ev && ev.venue_work_hours,
          ev && ev.work_hours,
          card.dataset && card.dataset.venueWorkHours,
          venue && venue.venue_work_hours,
          venue && venue.work_hours
        )
      };
    })(selectedCard);

    // Get quantity
    const quantityInput = form.querySelector('[name="quantity"]');
    const quantity = quantityInput ? Number(quantityInput.value) || 1 : 1;

    // Simple toast notification function
    function showToast(message, type = 'error') {
      // Create toast element
      const toast = document.createElement('div');
      toast.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: ${type === 'error' ? '#f44336' : '#4caf50'};
        color: white;
        padding: 16px 24px;
        border-radius: 4px;
        box-shadow: 0 4px 6px rgba(0,0,0,0.1);
        z-index: 10000;
        font-size: 14px;
        max-width: 400px;
        animation: slideIn 0.3s ease-out;
      `;
      toast.textContent = message;
      
      // Add animation
      const style = document.createElement('style');
      style.textContent = `
        @keyframes slideIn {
          from { transform: translateX(100%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
        @keyframes slideOut {
          from { transform: translateX(0); opacity: 1; }
          to { transform: translateX(100%); opacity: 0; }
        }
      `;
      if (!document.head.querySelector('#workshop-toast-styles')) {
        style.id = 'workshop-toast-styles';
        document.head.appendChild(style);
      }
      
      document.body.appendChild(toast);
      
      // Remove after 4 seconds
      setTimeout(() => {
        toast.style.animation = 'slideOut 0.3s ease-out';
        setTimeout(() => {
          if (toast.parentNode) {
            toast.parentNode.removeChild(toast);
          }
        }, 300);
      }, 4000);
    }

    // Capacity: AOGEN live validate only (fail-closed). Railway capacity webhook removed.
    async function validateCapacityBeforeAdd(eventId, requestedQuantity) {
      const verifyFail = {
        allowed: false,
        remainingCapacity: null,
        adjustedQuantity: 0,
        abort: true,
        message: 'We could not verify workshop capacity right now. Please try again.',
        cartData: null,
      };
      if (!eventId) {
        showToast(verifyFail.message);
        return verifyFail;
      }

      const liveApi = window.WorkshopCityEvents;
      if (!liveApi || typeof liveApi.validateAddToCart !== 'function') {
        showToast(verifyFail.message);
        return verifyFail;
      }

      try {
        if (typeof liveApi.ensureBookingConfig === 'function') {
          await liveApi.ensureBookingConfig({});
        }
        const selectedCard =
          document.querySelector('.workshop-event-card.is-selected') ||
          document.querySelector('#wb-event-list .wb-all__event-card.is-selected') ||
          document.querySelector('.wb-all__event-card.is-selected');
        const slot = {
          gid: String(eventId),
          id: String(eventId),
          event_metaobject_gid:
            (selectedCard && selectedCard.dataset.eventMetaobjectGid) || String(eventId),
          status: (selectedCard && selectedCard.dataset.eventStatus) || 'active',
          display_status:
            selectedCard && selectedCard.dataset.displayStatus
              ? selectedCard.dataset.displayStatus
              : undefined,
        };
        const verdict = await liveApi.validateAddToCart(slot, requestedQuantity, {
          intent: 'add_to_cart',
        });
        if (!verdict || verdict.allowed === false) {
          const message =
            (verdict && verdict.message) ||
            'This workshop no longer has enough available seats.';
          showToast(message);
          return {
            allowed: false,
            remainingCapacity:
              verdict && verdict.capacity_remaining != null
                ? Number(verdict.capacity_remaining)
                : 0,
            adjustedQuantity: 0,
            abort: true,
            message: message,
            cartData: (verdict && verdict.cartData) || null,
            capacity_as_of: verdict && (verdict.as_of || verdict.capacity_as_of),
            event_status: verdict && (verdict.event_status || verdict.status),
          };
        }
        return {
          allowed: true,
          remainingCapacity:
            verdict.capacity_remaining != null ? Number(verdict.capacity_remaining) : null,
          adjustedQuantity: requestedQuantity,
          message: '',
          cartData: verdict.cartData || null,
          capacity_as_of: verdict.as_of || verdict.capacity_as_of,
          event_status: verdict.event_status || verdict.status,
        };
      } catch (error) {
        console.warn('Workshop: Capacity check failed', error);
        showToast(verifyFail.message);
        return verifyFail;
      }
    }

    // Validate capacity before proceeding
    const capacityCheck = await validateCapacityBeforeAdd(selectedEventId, quantity);
    
    // If capacity check failed and we should abort, return early
    if (capacityCheck.abort === true) {
      return;
    }
    
    // If capacity check failed but we can adjust quantity, use adjusted quantity
    if (!capacityCheck.allowed && capacityCheck.adjustedQuantity > 0) {
      quantity = capacityCheck.adjustedQuantity;
      // Update quantity input to reflect adjusted value
      if (quantityInput) {
        quantityInput.value = quantity;
      }
    } else if (!capacityCheck.allowed) {
      // Should not happen if logic is correct, but fail-safe
      return;
    }

    // Line item properties — Cart Transform sadece _workshop ve _resolved_price* kullanır
    // _unique: variantId:eventId ile merge; aynı event+variant = tek satır
    let capacityRemaining = null;
    const capRaw =
      selectedCard?.dataset.capacityRemaining ||
      selectedCard?.getAttribute('data-capacity-remaining') ||
      null;
    if (capRaw != null) {
      const n = Number(capRaw);
      if (Number.isFinite(n) && n >= 0) {
        capacityRemaining = String(n);
      }
    }

    const uniqueId = `${variantId}:${selectedEventId}`;
    const centsStr = String(resolvedPriceCents ?? '').trim();
    const validCents = /^[0-9]+$/.test(centsStr) && parseInt(centsStr, 10) > 0;
    const eventMetaobjectGid = selectedCard?.dataset?.eventMetaobjectGid ? String(selectedCard.dataset.eventMetaobjectGid) : selectedEventId;
    // Line item properties: Shopify maps these to cart line attributes for Cart Transform
    const properties = {
      _workshop: 'true',
      _event_id: selectedEventId,
      _event_metaobject_gid: eventMetaobjectGid,
      _event_handle: eventHandle,
      _display_city: displayCity,
      _display_venue: displayVenue,
      _display_datetime: displayDatetime,
      _unique: uniqueId,
      _is_workshop: "1",
      "Booking Details": bookingDetailsVisible
    };
    if (venueContact.address) properties._venue_address = venueContact.address;
    if (venueContact.phone) properties._venue_phone = venueContact.phone;
    if (venueContact.hours) properties._venue_hours = venueContact.hours;
    if (validCents) {
      properties._resolved_price_cents = centsStr;
      properties._resolved_price = centsStr;
    } else {
      console.warn('[Workshop] Missing/invalid resolved cents', { resolvedPriceCents, variantId, eventId: selectedEventId });
    }
    if (capacityRemaining !== null) {
      properties._capacity_remaining = capacityRemaining;
      properties._capacity_source = 'metaobject_dom';
    }

    var validationSlot = {
      gid: selectedEventId,
      status:
        selectedCard && selectedCard.dataset.eventStatus
          ? selectedCard.dataset.eventStatus
          : 'active',
      capacity_remaining: capacityRemaining != null ? Number(capacityRemaining) : null,
      capacity_as_of: capacityCheck && capacityCheck.capacity_as_of ? capacityCheck.capacity_as_of : null,
    };
    if (window.WorkshopCityFlow && typeof window.WorkshopCityFlow.appendCartValidationProperties === 'function') {
      if (capacityCheck && capacityCheck.remainingCapacity != null) {
        validationSlot.capacity_remaining = capacityCheck.remainingCapacity;
      }
      if (capacityCheck && capacityCheck.event_status) {
        validationSlot.status = capacityCheck.event_status;
      }
      Object.assign(
        properties,
        window.WorkshopCityFlow.appendCartValidationProperties(validationSlot, properties)
      );
    } else if (capacityCheck && capacityCheck.event_status) {
      properties._event_status = String(capacityCheck.event_status);
    }

    // Hard guard: prevent duplicate add within 1s (same event + variant + quantity)
    const addLockKey = selectedEventId + '|' + variantId + '|' + quantity;
    const lock = window.__WB_ADD_LOCK__;
    if (lock && (Date.now() - lock.ts) < 1000 && lock.key === addLockKey) {
      if (window.__WB_DIAG__) console.warn('[Workshop Cart] Duplicate add blocked (lock)', { key: addLockKey });
      e.preventDefault();
      return;
    }
    window.__WB_ADD_LOCK__ = { key: addLockKey, ts: Date.now() };

    const submitBtn = form.querySelector('button[type="submit"], button[name="add"]');
    const originalText = submitBtn ? submitBtn.textContent : '';
    window.__WORKSHOP_ADDING_TO_CART__ = true;
    let responseData;
    try {
      if (window.__WB_DIAG__) console.log('[Workshop Cart] REQUEST START add to cart', { eventId: selectedEventId, variantId: variantId, quantity: quantity });
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding...';
      }
      const sectionsToRender = window.Alpine && window.Alpine.store && window.Alpine.store('xCartHelper')
        ? window.Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id)
        : [];
      const root = (window.Shopify?.routes?.root || '/');
      const payload = buildCartAddPayload(variantId, quantity, properties, sectionsToRender);
      const endpoint = root + 'cart/add.js';

      const addResponse = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      responseData = await addResponse.json().catch(() => ({}));
      if (!addResponse.ok || responseData?.status === 422) {
        const desc = (responseData && responseData.description) ? String(responseData.description).toLowerCase() : '';
        const capacityRelated = /capacity|sold out|spots|seats|full|remaining|maximum|booked/.test(desc);
        const msg = capacityRelated && capacityCheck && capacityCheck.message
          ? capacityCheck.message
          : (responseData?.description || 'Unable to add to cart. Please try again.');
        alert(msg);
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
        }
        return;
      }
      if (validCents && capacityCheck.cartData) {
        try {
          var cartData = capacityCheck.cartData;
          var prices = {};
          try {
            if (cartData.attributes && cartData.attributes._workshop_prices) {
              prices = JSON.parse(cartData.attributes._workshop_prices);
            }
          } catch (_) {}
          prices[uniqueId] = centsStr;
          var keep = {};
          (cartData.items || []).forEach(function(it) {
            var u = it.properties && it.properties._unique;
            if (!u && it.properties && it.properties._event_metaobject_gid) u = (it.variant_id || it.id) + ':' + it.properties._event_metaobject_gid;
            if (u && prices[u] != null) keep[u] = prices[u];
          });
          if (keep[uniqueId] == null) keep[uniqueId] = centsStr;
          await fetch(root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { _workshop_prices: JSON.stringify(keep) } })
          });
        } catch (attrErr) {
          if (window.__WB_DIAG__) console.warn('[Workshop Cart] cart.attributes update failed', attrErr);
        }
      }
      if (responseData.sections && window.Alpine && window.Alpine.store && window.Alpine.store('xCartHelper')) {
        window.Alpine.store('xCartHelper').reRenderSections(responseData.sections);
      }
      if (window.Alpine && window.Alpine.store && window.Alpine.store('xCartHelper')) {
        window.Alpine.store('xCartHelper').currentItemCount = parseInt(document.querySelector('#cart-icon-bubble span')?.innerHTML || '0');
      }
      document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
      if (window.Shopify && window.Shopify.theme && window.Shopify.theme.cartType === 'page') {
        window.location.href = '/cart';
      } else {
        if (window.Alpine && window.Alpine.store && window.Alpine.store('xMiniCart')) {
          if (!window.Alpine.store('xCartNoti') || !window.Alpine.store('xCartNoti').enable) {
            window.Alpine.store('xMiniCart').openCart();
          }
        }
      }
    } catch (err) {
      console.error('Workshop cart error:', err);
      const desc = (err && err.message) ? String(err.message).toLowerCase() : '';
      const capacityRelated = /capacity|sold out|spots|seats|full|remaining|maximum|booked/.test(desc);
      const msg = capacityRelated && capacityCheck && capacityCheck.message
        ? capacityCheck.message
        : 'Unable to add to cart. Please try again.';
      alert(msg);
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = originalText;
      }
    } finally {
      window.__WORKSHOP_ADDING_TO_CART__ = false;
      window.__WB_ADD_LOCK__ = null;
    }
  });

  if (window.__DEBUG_WORKSHOP_CAPACITY__) {
    console.log('[Workshop Cart] Event listeners attached');
  }
});
})(); // End IIFE guard
